/**
 * The query param that holds which player's details are open
 * (`?playerDetails=<id>`). One name across every entry point — profile, Player
 * page, team roster, Team Budget — so a shared link reads the same everywhere.
 */
export const PLAYER_DETAILS_PARAM = 'playerDetails'

/** The query param that holds an open Add Player screen (`?addPlayer=new`). */
export const ADD_PLAYER_PARAM = 'addPlayer'

/** `ADD_PLAYER_PARAM`'s value for creating a new player. */
export const ADD_PLAYER_NEW = 'new'
